var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "24",
        height: "24",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M3.19997 2.1333C2.61063 2.1333 2.1333 2.61063 2.1333 3.19997V4.26663H4.26663V2.1333H3.19997ZM5.3333 2.1333V4.26663H7.46663V2.1333H5.3333ZM8.5333 2.1333V4.26663H10.6666V2.1333H8.5333ZM11.7333 2.1333V4.26663H13.8666V3.19997C13.8666 2.61063 13.3893 2.1333 12.8 2.1333H11.7333ZM2.1333 5.3333V7.46663H4.26663V5.3333H2.1333ZM5.3333 5.3333V7.46663H7.46663V5.3333H5.3333ZM8.5333 5.3333V7.46663H10.6666V5.3333H8.5333ZM11.7333 5.3333V7.46663H13.8666V5.3333H11.7333ZM2.1333 8.5333V10.6666H4.26663V8.5333H2.1333ZM5.3333 8.5333V10.6666H7.46663V8.5333H5.3333ZM8.5333 8.5333V10.6666H10.6666V8.5333H8.5333ZM11.7333 8.5333V10.6666H13.8666V8.5333H11.7333ZM2.1333 11.7333V12.8C2.1333 13.3893 2.61063 13.8666 3.19997 13.8666H4.26663V11.7333H2.1333ZM5.3333 11.7333V13.8666H7.46663V11.7333H5.3333ZM8.5333 11.7333V13.8666H10.6666V11.7333H8.5333ZM11.7333 11.7333V13.8666H12.8C13.3893 13.8666 13.8666 13.3893 13.8666 12.8V11.7333H11.7333Z",
          fill: "CurrentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }